export default {
  manufacturerDevices: state => state.manufacturerDevices,
  connectedDevices: state => state.connectedDevices,
  isLoading: state => state.loading,
  contextError: state => state.error
}



// WEBPACK FOOTER //
// ./src/store/modules/connecteddevices/getters.js